import React from 'react';
import { useEnabledFeatures } from '../common/hooks/enabled-features';
import { electronBridge } from './electron-bridge';

/**
 * Keeps the Electron power save blocker in step with the department preference.
 *
 * The blocker itself lives in the Electron main process, which only reads enabled features once at
 * bootstrap. Without this the preference would not take effect until the next login, so pushing the
 * current value from here lets a department be opted in or out of honouring the operating system's
 * inactivity screen-lock policy while the app stays open.
 */
export function useSyncPowerSaveBlocker(): void {
    const { disablePowerSaveBlockerEnabled } = useEnabledFeatures();

    React.useEffect(
        function pushPowerSaveBlockerPreferenceToMain() {
            electronBridge?.setPowerSaveBlockerDisabled?.(disablePowerSaveBlockerEnabled);
        },
        [disablePowerSaveBlockerEnabled]
    );
}
